import { UseQueryDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTaskRepository } from '@front/repository/Api/ImportTask';
import { useQuery } from '@tanstack/react-query';
import { AuthDomain } from 'auth-lib-front';
import { DomainV2 } from 'troppus-common/domain';

import Project = AuthDomain.Object.Project;
import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;
import ImportTableDefinitionRevision = DomainV2.Import.ImportTableDefinitionRevision;

import { importTaskQueryKeys } from './queryKeys';

const repository = new ImportTaskRepository();

type Options = {
  enabled?: boolean;
  importTableDefinitionId?: ImportTableDefinition.Id;
  importTableDefinitionRevisionId?: ImportTableDefinitionRevision.Id;
  /** 未完了タスクがある間だけ指定間隔（ms）で再取得する */
  pollIntervalMs?: number;
};

export const _list = (projectId: Project.Id, options?: Options) => {
  const pollIntervalMs = options?.pollIntervalMs;

  return useQuery({
    queryKey: importTaskQueryKeys.list(projectId, options?.importTableDefinitionId, options?.importTableDefinitionRevisionId),
    queryFn: async ({ signal }) => {
      return repository.list(
        {
          projectId,
          importTableDefinitionId: options?.importTableDefinitionId,
          importTableDefinitionRevisionId: options?.importTableDefinitionRevisionId,
        },
        { signal: signalToTimeout(DEFAULT_TIMEOUT.QUERY, signal) },
      );
    },
    enabled: options?.enabled ?? true,
    ...UseQueryDefaultOptions,
    refetchInterval: (query) => {
      if (pollIntervalMs === undefined) return false;
      const tasks = query.state.data;
      if (!tasks || tasks.length === 0) return false;
      const hasIncomplete = tasks.some((task) => task.status === 'Requested' || task.status === 'Started');
      return hasIncomplete ? pollIntervalMs : false;
    },
    refetchIntervalInBackground: false,
  });
};
